module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_4-117c455f597df17f4a9e03e13584c27c.gif";